<template>
	<div v-if="is_logged_in"  class="home col-md-10 col-md-offset-1">

		<div class="panel panel-default drop-shadow"  style=" min-height:400px; height:auto; overflow:hidden;">
			<div class="panel-heading panel-grey text-left">
				SETTINGS
			</div>

			<div style="padding:5px;">
				<div  v-if="$mq !== 'mobile'"  id="exTab3" class="col-md-2">
					<ul class="nav nav-tabs nav-stacked">
						<li>&nbsp;</li>
						<li  v-bind:class="{ active: show_section == 1 }"><a href="#" @click="show_section = 1">Contact Info</a></li>
						<li  v-bind:class="{ active: show_section == 2 }"><a href="#" @click="show_section = 2">Change Password</a></li>
                        <!--
						<li  v-bind:class="{ active: show_section == 3 }"><a href="#" @click="show_section = 3">Preferences</a></li>
						<li  v-bind:class="{ active: show_section == 4 }"><a href="#" @click="show_section = 4">Payment</a></li>
                        -->
						<li>&nbsp;</li>
						<li>&nbsp;</li>
						<li>&nbsp;</li>
						<li>&nbsp;</li>
						<li>&nbsp;</li>
						<li>&nbsp;</li>
					</ul>
				</div>
				<div  v-else  id="exTab2">
					<center>
						<ul class="nav nav-pills nav-justified" style='width:90%;'>
                            <li  v-bind:class="{ active: show_section == 1 }"><a href="#" @click="show_section = 1">Contact Info</a></li>
                            <li  v-bind:class="{ active: show_section == 2 }"><a href="#" @click="show_section = 2">Change Password</a></li>
						</ul>
                    </center>
                    <hr>
				</div>
	
				<div class="no-padding">
					<!--
					**********************
					**** Contact Info ****
					********************** -->
					<div v-show="show_section == 1">
						<div v-if="got_user == true"  style="padding:5px;">
							<table>
								<tr>
									<td class='text-right'  style="padding:5px;"><b>Name:</b></td>
									<td class='text-left'   style="padding:5px;">{{ user.name }}</td>
								</tr>
								<tr>
									<td class='text-right'  style="padding:5px;"><b>Email:</b></td>
									<td class='text-left'   style="padding:5px;">{{ user.email }}</td>
								</tr>
								<tr>
									<td class='text-right'  style="padding:5px;"><b>Type:</b></td>
									<td class='text-left'   style="padding:5px;">{{ (user.type).toUpperCase() }}</td>
								</tr>
								<tr>
                                    <td colspn=2>&nbsp;</td>
                                </tr>
								<tr>
									<td class='text-right'  style="padding:5px;"><b>Account Created:</b></td>
									<td class='text-left'   style="padding:5px;">{{ user.created_at | moment("HH:mm:ss, Do MMM YYYY") }}</td>
								</tr>
							</table>
						</div>

                        <div v-else  style="padding:5px; text-align:left;">
                            Fetching user information...
                        </div>
                    </div>

					<!--
					*************************
					**** Change Password ****
					************************* -->
					<div v-show="show_section == 2">
						<div style="padding:5px;">
							<table>
								<tr>
									<td class='text-right' style="padding:20px;"><b>Current password:</b></td>
									<td class='text-left'>
										<input  name="current_password"  
                                                placeholder="Current password"
                                                type="password"  class="form-control" style='width:160px;' autofocus
												v-validate="'required|max:250'"
												v-model="current_password"
										>
										<span class="text-danger">{{ errors.first('change_password') }}</span>
									</td>
								</tr>
								<tr>
									<td class='text-right' style="padding:20px;"><b>New Password:</b></td>
									<td class='text-left'>
										<input  name="new_password"  ref="new_password"
                                                placeholder="New password"
                                                type="password"  class="form-control" style='width:160px;'
												v-validate="'required|min:8|max:50'"
												v-model="new_password"
										>
										<span class="text-danger">{{ errors.first('new_password') }}</span>
									</td>
								</tr>
								<tr>
									<td class='text-right' style="padding:20px;"><b>Re-type Password:</b></td>
									<td class='text-left'>
										<input  name="confirm_password"  
                                                placeholder="Re-type new"
                                                type="password"  class="form-control" style='width:160px;'
												v-validate="'required|confirmed:new_password'"
												v-model="confirm_password"
										>
										<span class="text-danger">{{ errors.first('confirm_password') }}</span>
									</td>
								</tr>
								<tr>
                                    <td colspn=2>&nbsp;</td>
                                </tr>
								<tr>
                                    <td></td>
									<td class='text-left'>
										<button  v-if="requesting == false"
                                                 name="button"  type="submit"  class="btn btn-primary" style="width:120px;"
												 @click="change_password()"
                     							 :disabled="errors.any() || !is_complete"
										>Submit</button>

                                        <button v-else  disabled
                                                name="button"   type="submit"  class="btn btn-primary" style="width:120px;">
                                            <i class="fas fa-circle-notch fa-spin"></i>
                                        </button>
									</td>
								</tr>
							</table>
						</div>
					</div>
					
					<div v-show="show_section == 3">Tab 3</div>
					<div v-show="show_section == 4">Tab 4</div>
				</div>
			</div>
		</div>
	</div>

	<div v-else  class="home">
		<div class="panel panel-default drop-shadow"  style=" min-height:400px; height:auto; overflow:hidden;">
			<div class="panel-heading panel-grey text-left">
				SETTINGS
			</div>
        </div>
    </div>
</template>


<script>
import EventBus from '@/event_bus';					// Event Bus

export default {
	name: 'settings',

	props: {
	},
	
	components: {
        EventBus
	},
	
	data() {
		return {
            requesting:       false,
            got_user:         false,
            
            user:             {},
			api_token:        '',
			show_section:     1,
            current_password: '',
            new_password:     '',
            confirm_password: '',
		};
	},

	computed: {
        is_complete() {
            return this.current_password && this.new_password && this.confirm_password;
        },		
	},
	
	created() {
		if (this.is_logged_in()) {
			this.get_user_info();
		}
	},

	mounted() {
	},
	
	destroyed() {
	},

	methods: {
		is_logged_in() {
			var status     = false;
			this.api_token = localStorage.getItem('api_token');
			
			if (this.api_token  &&  this.api_token.length == 64) {
				status = true;
			}
				
			return status;
		},

		// Get User Info
		get_user_info() {
			this.got_user = false;
			
            const post_data = {
                api_token:        this.api_token,
            };

            this.axios.post('api/user_info', post_data)
            .then(response => {
                this.got_user = true;
                this.user     = response.data;

                //this.$router.push('/');
            })
            .catch(error => {
                var error_msg     = '';
                var error_details = '';

                if (error.response) {
                    if (error.response.data.message) {
                        error_msg = error.response.data.message;	
                    }
                    
                    if (error.response.data.error) {
                        Object.keys(error.response.data.error).forEach(key => {
                            error_details = error_details + error.response.data.error[key].toString() + "<br>";

                            // load api errors into client errors
                            this.errors.add({
                                field: key,
                                msg:   error.response.data.error[key].toString(),
                            });
                        });
                    }

                    this.$notify({
                        group: 'fs_danger',
                        title: error_msg,
                        text:  error_details,
                        type:  'error'
                    });
                }
                else if (error.message == "Network Error") {
                    localStorage.removeItem('api_token');
                    this.$store.commit("RESET");
                    this.api_token = null;

                    this.$notify({
                        group: "fs_warning",
                        title: "Session has expired",
                        text:  "Please log in again.",
                        type:  "error"
                    });

                    EventBus.$emit('refresh_header_api_token', this.api_token);
                    this.$router.push({'name': 'home'});
                }
                else {
                    this.$notify({
                        group: "fs_danger",
                        title: "Error",
                        text: "Unexpected error.<br>Suggest logging out and back in again.",
                        type: "error"
                    });
                }
            });
		},

		// Change Password
		change_password() {
			this.requesting = true;
			
			this.$validator.validateAll()
			.then(() => {
				const post_data = {
                    api_token:        this.api_token,
					current_password: this.current_password,
                    new_password:     this.new_password,
                    confirm_password: this.confirm_password,
				};

				this.axios.post('api/change_password', post_data)
				.then(response => {
                    this.requesting = false;
                    
					this.$notify({
						group:    'fs_success',
						title:    'Success',
						text:     'Password changed.',
						//duration: 3000,
						type:     'success'
					});
					
					//this.$router.push('/files');
				})
				.catch(error => {
					this.requesting = false;
			
					var error_msg     = '';
					var error_details = '';
					if (error.response) {
                        if (error.response.data.message) {
                            error_msg = error.response.data.message;	
                        }
                        
                        if (error.response.data.error) {
                            Object.keys(error.response.data.error).forEach(key => {
                                error_details = error_details + error.response.data.error[key].toString() + "<br>";

                                // load api errors into client errors
                                this.errors.add({
                                    field: key,
                                    msg:   error.response.data.error[key].toString(),
                                });
                            });
                        }

                        this.$notify({
                            group: 'fs_danger',
                            title: error_msg,
                            text:  error_details,
                            type:  'error'
                        });
                    }
                    else {
                        console.log('changePassword()  unexpected error: ', JSON.stringify(error));
                    }
				});
			})
			.catch(() => {
				this.requesting = false;
			
				this.$notify({
					group: 'fs_danger',
					title: 'Error',
					text:  this.errors.all(),
					type:  'error'
				});
			});
		},
	},
}

</script>
